import { createReducer } from 'typesafe-actions';
import { ProductFormatter } from '@westwing/appshell-formatting-helpers';
import { defaultErrorHandler, defaultRequestHandler } from '../dataFetching/generators';
import { ProductLooksState } from './types';
import {
    fetchProductLooksActions,
    ProductLooksActionsType,
    resetLooksInfusionSliderViewAction,
    setLooksInfusionSliderViewAction,
} from './action';

export const initialProductLooksState: ProductLooksState = {
    didInvalidate: false,
    identifier: '',
    isFetching: false,
    wasLooksInfusionViewed: false,
    looks: [],
};

export const productLooksReducer = createReducer<ProductLooksState, ProductLooksActionsType>(initialProductLooksState)
    .handleAction(setLooksInfusionSliderViewAction, state => ({
        ...state,
        wasLooksInfusionViewed: true,
    }))
    .handleAction(resetLooksInfusionSliderViewAction, state => ({
        ...state,
        wasLooksInfusionViewed: false,
    }))
    .handleAction(fetchProductLooksActions.request, defaultRequestHandler)
    .handleAction(fetchProductLooksActions.success, (state, action) => {
        const { data, identifier, reducerPayloadOptions: { countryCode = '', currency = '' } = {} } = action.payload;

        const looks = data.looks.map(rawProductLook => {
            const products = rawProductLook.products.map((value, index) => {
                const product = ProductFormatter(index, value, undefined, undefined, { countryCode, currency });

                return {
                    ...product,
                };
            });

            return {
                isLandscape: rawProductLook.isLandscape,
                trackingName: rawProductLook.trackingName,
                name: rawProductLook.name,
                slug: rawProductLook.slug,
                caption: rawProductLook.caption,
                color: rawProductLook.color,
                portraitListingImage: rawProductLook.portraitListingImage,
                moodImage: rawProductLook.moodImage,
                genericImagePortrait: rawProductLook.genericImagePortrait,
                products,
            };
        });
        return {
            ...state,
            identifier,
            isFetching: false,
            didInvalidate: false,
            looks,
        };
    })
    .handleAction(fetchProductLooksActions.failure, (state, action) => defaultErrorHandler(state, action));
